import { render, staticRenderFns } from "./VideoMonitor.vue?vue&type=template&id=010f17ad&scoped=true"
import script from "./VideoMonitor.vue?vue&type=script&lang=js"
export * from "./VideoMonitor.vue?vue&type=script&lang=js"
import style0 from "./VideoMonitor.vue?vue&type=style&index=0&id=010f17ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010f17ad",
  null
  
)

export default component.exports